import { Button2 } from '@frameio/vapor';
import { useShouldShowTruncatedAccessRequestsList } from '../../contexts/ShouldShowTruncatedAccessRequestsList';
import TEXT from './generated/TEXT/ShowAllAccessRequestsButton';
import styles from './ShowAllAccessRequestsButton.module.css';

TEXT.DEFINE({
  /** CTA to expand the truncated access requests list */
  cta: 'Show all',
});

export function ShowAllAccessRequestsButton() {
  const { setShouldShowTruncatedAccessRequestsList } =
    useShouldShowTruncatedAccessRequestsList();

  return (
    <div className={styles.showAllAccessRequestsButtonContainer}>
      <Button2
        block={true}
        className={styles.showAllAccessRequestsButton}
        onPress={() => setShouldShowTruncatedAccessRequestsList(false)}
        variant="tertiary"
      >
        {TEXT.cta}
      </Button2>
    </div>
  );
}
